import styles from "./styles/vocal-remover-steps-to-isolate.module.scss";
import step1Image from "@/assets/vocal-remover/vocal-remove-step-1.webp";
import step2Image from "@/assets/vocal-remover/vocal-remove-step-2.webp";
import step3Image from "@/assets/vocal-remover/vocal-remove-step-3.webp";
import VocalRemoverStep from "@/components/pages/vocal-remover/components/vocal-remover-steps-to-isolate/vocal-remover-step";
import { useMobile } from "@/hooks/use-responsive";

const VocalRemoverStepsToIsolate = () => {
  const { isMobile } = useMobile();
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        3 Steps to Isolate {isMobile && <br />} <span>Vocals from a Song</span>
      </div>
      <div className={styles.subtitle}>
        You can separate different tracks from songs by following the steps
        below, <br /> or check out all the vocals & instrumentals isolated by
        our users and download the ones you need.
      </div>
      <div className={styles.steps_wrapper}>
        <VocalRemoverStep
          image={step1Image.src}
          stepNumber={1}
          description={"Upload a file or paste a video/audio URL."}
        />
        <VocalRemoverStep
          image={step2Image.src}
          stepNumber={2}
          description={"Start vocal removal."}
        />
        <VocalRemoverStep
          image={step3Image.src}
          stepNumber={3}
          description={"Save the vocals and the instrumental audio."}
        />
      </div>
    </div>
  );
};

export default VocalRemoverStepsToIsolate;
